import Route from "vue-routisan";
import isAuthenticated from "../middlewares/isAuthenticated";
import isTransporter from "../middlewares/isTransporter";
import hasTrackingPermission from "@/http/routes/middlewares/hasPermission/hasTrackingPermission";

Route.group({}, () => {


    Route.group({prefix:'truck_position', beforeEnter: [isAuthenticated,hasTrackingPermission]}, () =>{
      Route.group({prefix: "transporter", beforeEnter: [isTransporter]}, () => {

        Route.group({prefix: "tracking_solicitation"}, () => {

        Route.view("/", () =>
          import(/* webpackChunkName: "transporter" */ "src/resources/views/truckPosition/transporter/trackingSolicitation/TrackingSolicitationList")
        ).name("transporter.tracking")
          .options({
            meta: {
              // visibilityPermission: ["financier"],
              layout: () => import(/* webpackChunkName: "transporter" */ "src/resources/views/truckPosition/transporter/layout/Layout.vue")
            }
          })

        Route.view("/", () =>
          import(/* webpackChunkName: "transporter" */ "src/resources/views/truckPosition/transporter/trackingSolicitation/TrackingSolicitationList")
        ).name("transporter.tracking_solicitation")
          .options({
            meta: {
              // visibilityPermission: ["financier"],
              layout: () => import(/* webpackChunkName: "transporter" */ "src/resources/views/truckPosition/transporter/layout/Layout.vue")
            }
          })

        Route.view("/create", () =>
          import(/* webpackChunkName: "transporter" */ "src/resources/views/truckPosition/transporter/trackingSolicitation/TrackingSolicitationCreate")
        ).name("transporter.tracking_solicitation_create")
          .options({
            meta: {
              // visibilityPermission: ["financier"],
              layout: () => import(/* webpackChunkName: "transporter" */ "src/resources/views/truckPosition/transporter/layout/Layout.vue")
            }
          })

        Route.view("/update/:id", () =>
          import(/* webpackChunkName: "transporter" */ "src/resources/views/truckPosition/transporter/trackingSolicitation/TrackingSolicitationUpdate")
        ).name("transporter.tracking_solicitation_update")
          .options({
            meta: {
              // visibilityPermission: ["financier"],
              layout: () => import(/* webpackChunkName: "transporter" */ "src/resources/views/truckPosition/transporter/layout/Layout.vue")
            }
          })

      });
    })

  });
});

export default Route.all();
